<template>
  <div class="main">
  	<goBack></goBack>
    <div class="top">
    	<div class="top-title">搜索结果（{{total1 + total2 + total3}}）</div>
    	<el-input class="top-input" v-model="keyword" placeholder="搜索关键字，搜索课程、用户、知识">
    		<el-button slot="append" icon="el-icon-search" @click="toSeach"></el-button>
    	</el-input>
    </div>
    <div class="sel">
    	<div v-for="item in selList" class="list" :class="curtypeurl == item.type ? 'list-sel' : 'list-not'" @click="selType(item.type)">{{item.name}}<span v-if="item.type == 'user'">({{total1}})</span><span v-else-if="item.type == 'course'">({{total2}})</span><span v-else-if="item.type == 'posts'">({{total3}})</span></div>
    </div>
    <div v-if="curtypeurl == 'user'">
	    <div class="user" v-if="userList.length">
	    	<div v-for="(item , index) in userList" class="u-list">
	    		<div class="u-list-left" @click="$router.push({name: 'personalCenter', params: {id: item.user_id}})">
	    			<img :src="$avatarHash(item.user_id)" class="u-img">
	    			<img v-if="item.vip == 440" src="/static/img/law.png" class="lawyer-img">
	    			<div>
	    				<div v-if="item.vip == 440"><span class="u-name" v-html="item.real_name"></span>（<span class="u-names" v-html="item.user_name"></span>）</div>
	    				<div v-else><span class="u-name" v-html="item.user_name"></span></div>
	    				<div class="u-company">{{item.company}}</div>
	    				<div class="u-tags" v-if="item.vip == 440">
	    					<div class="u-tag-list" v-html="item.speciality"></div>
	    				</div>
	    			</div>
	    		</div>
	    		<div class="u-list-right">
	    			<div class="follow" v-if="item.follow == 0" @click="follow(item.user_id,index)">关注</div>
	    			<div class="follow" v-else @click="unfollow(item.user_id,index)">已关注</div>
	    			<div class="consult" @click="gotoChat(item.user_id)">咨询</div>
	    		</div>
	    	</div>
    	</div>
    	<div class="bottom" v-if="userList.length">
    		<el-pagination
    		  v-if="total1 > perpage1"
			  background
			  :current-page.sync="page1"
			  :page-size="perpage1"
			  @current-change="handleCurrentChange"
			  layout="prev, pager, next, total"
			  :total="total1">
			</el-pagination>
			<div v-else class="nodata">没有更多啦！</div>
    	</div>
    	<div v-if="!userList.length" class="no-search">
    		<img src="/static/img/no_search.png" class="no-img">
    		<div>无搜索结果!</div>
    	</div>
    </div>
    <div v-if="curtypeurl =='course'">
	    <div class="course" v-if="courseList.length">
	    	<div v-for="(item , index) in courseList" class="c-list" @click="$router.push({name: 'courseInfo', params: {course_id: item.id}})">
	    		<img :src="item.cover" class="c-img">
				<div class="c-lists">
					<div class="c-title">{{item.title}}</div>
					<div class="c-name">主讲人：{{item.speaker}}</div>
					<div class="c-time">活动时间：{{item.start_time}}-{{item.end_timehm}}</div>
					<div class="c-btn">
						<div class="c-type" v-if="item.catagory == '企业法务通'">{{item.catagory}}</div>
						<div class="c-type c-type-fldjt" v-else-if="item.catagory == '法律大讲堂'">{{item.catagory}}</div>
						<div class="c-type c-type-no" v-else>{{item.catagory}}</div>
						<div v-if="item.issign" class="c-sign">报名中</div>
	        			<div v-else class="c-sign c-over">已结束</div>
					</div>
				</div>
	    	</div>
    	</div>
    	<div class="bottom" v-if="courseList.length">
    		<el-pagination
    		  v-if="total2 > perpage2"
			  background
			  :current-page.sync="page2"
			  :page-size="perpage2"
			  @current-change="handleCurrentChange2"
			  layout="prev, pager, next, total"
			  :total="total2">
			</el-pagination>
			<div v-else class="nodata">没有更多啦！</div>
    	</div>
    	<div v-if="!courseList.length" class="no-search">
    		<img src="/static/img/no_search.png" class="no-img">
    		<div>无搜索结果!</div>
    	</div>
    </div>
    <div v-if="curtypeurl =='posts'">
	    <div class="post"  v-if="postList.length">
	    	<div v-for="(item , index) in postList" class="p-list" @click="$router.push({name: 'post', params: {post_id: item.post_id}})" @contextmenu.prevent="leftToPost(item.post_id)" title="点击右键新开窗口跳转">
	    		<div class="p-top">
	    			<div class="p-t-dian"></div>
	    			<div class="p-t-title" v-html="item.post_title"></div>
	    		</div>
	    		<div class="p-bottom">
	    			<div>作者  {{item.creator_name}}</div>
	    			<div>|</div>
	    			<div>更新  {{item.update_time}}</div>
	    			<div>|</div>
	    			<div>浏览  {{item.pv_num}}</div>
	    		</div>
	    	</div>
    	</div>
    	<div class="bottom" v-if="postList.length">
    		<el-pagination
    		  v-if="total3 > perpage3"
			  background
			  :current-page.sync="page3"
			  :page-size="perpage3"
			  @current-change="handleCurrentChange3"
			  layout="prev, pager, next, total"
			  :total="total3">
			</el-pagination>
			<div v-else class="nodata">没有更多啦！</div>
    	</div>
    	<div v-if="!postList.length" class="no-search">
    		<img src="/static/img/no_search.png" class="no-img">
    		<div>无搜索结果!</div>
    	</div>
    </div>
  </div>
</template>

<script>
import goBack from '@/components/common/goBack';
export default {
  name: 'Search',
  data () {
    return {
      keyword:'',
      curtypeurl:'',
      selList:[
      	{type:'posts',name:'知识'},
      	{type:'user',name:'用户'},
      	{type:'course',name:'课程'}
      ],
      page1:1,
      total1:0,
      perpage1:8,
      userList:[],
      page2:1,
      total2:0,
      perpage2:12,
      courseList:[],
      page3:1,
      total3:0,
      perpage3:12,
      postList:[]
    }
  },
  components: {
    goBack
  },
  beforeMount() {
    this.keyword = this.$route.query.keyword;
    this.curtypeurl = this.$route.query.type || 'posts';  //user用户  posts知识  information资讯  course课程
    // console.log('111',this.$route.query);
  },
  computed: {
    loginStatus() {
      return this.$store.state.loginStatus;
    }
  },
  mounted(){
  	this.getUserList();
  	this.getCourseList();
  	this.getpostList();
  },
  methods:{
  	back(){
        this.$router.go(-1);
    },
    //右击新窗口挑战知识
    leftToPost(post_id){
    	let details = this.$router.resolve({
          name: "post",
          params: {
            post_id:post_id
          }
        });
        window.open(details.href, "_blank");
    },
  	//搜索
  	toSeach(){
  		this.page1=1;
  		this.page2=1;
  		this.page3=1;
  		this.getUserList();
  		this.getCourseList();
  		this.getpostList();
  		var query = {
  			keyword:this.keyword
  		};
  		if(this.$route.query.type){
  			query.type = this.curtypeurl
  		};
  		this.$router.replace({path:'/search',query:query});
  	},
  	//选择标签
  	selType(type){
  		this.curtypeurl = type;
  	},
  	//获取用户列表
  	getUserList(){
  		var url = 'search/user/'+ this.keyword;
  		var params = {
  			page:this.page1,
  			perpage:8
  		}
  		this.$http.get(url,{params:params}).then(res => {
  			if(res.data.retcode == 0){
  				// console.log('user',res.data);
  				this.userList = res.data.data;
  				this.total1 = res.data.total;
  			}
  		})
  	},
  	handleCurrentChange(val) {
      this.page1 = val;
      this.getUserList();
    },
    // 关注
    follow(id,index) {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        return;
      }
      this.$ajax('post', 'user/follow/' + id, data => {
        this.userList[index].follow = 1;
        this.$message.success( '关注成功！' );
      });
    },
    // 取关
    unfollow(id,index) {
      this.$ajax('post', 'user/unfollow/' + id, data => {
        this.userList[index].follow = 0;
        this.$message.success( '已取消关注！' );
      });
    },
    gotoChat(id) {
      if( !this.loginStatus ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      // this.$gotov1('/feed?v2chat=' + this.userInfo.id);
      this.startGetInfo(id)

    },

    startGetInfo(uid) {
      this.$ajax('get', `/userinfo/detail/${uid}`, (data) => {
          this.startChat(data.data);
      });
    },
    startChat(user) {
        if(this.$store.state.mineInfo && this.$store.state.mineInfo.id){
            this.$store.commit("changeCurcontactInfo", { id: user.id, name: user.name});

            if(!this.isshowchatpanel){
                this.$store.commit('setSide', 'chat');
            }
        }else{
            this.$Message.error('未登录，请先登录后再发起私信！');
        }
    },
  	//获取课程列表
  	getCourseList(){
  		var url = 'wxm/course/index';
  		var params = {
  			page:this.page3,
  			per_page:12,
  			title:this.keyword
  		}
  		this.$http.get(url,{params:params}).then(res => {
  			if(res.data.retcode == 0){
  				// console.log('course',res.data);
  				this.courseList = res.data.data.data;
  				this.total2 = res.data.data.total;
  			}
  		})
  	},
  	handleCurrentChange2(val) {
      this.page2 = val;
      this.getCourseList();
    },
  	//获取知识列表
  	getpostList(){
  		var url = 'search/posts/'+ this.keyword;
  		var params = {
  			page:this.page3,
  			perpage:12
  		}
  		this.$http.get(url,{params:params}).then(res => {
  			if(res.data.retcode == 0){
  				// console.log('post',res.data);
  				this.postList = res.data.data;
  				this.total3 = res.data.total;
  			}
  		})
  	},
  	handleCurrentChange3(val) {
      this.page3 = val;
      this.getpostList();
    },
  },
  watch:{
		$route(to,from){
		    this.keyword = to.query.keyword;
		    this.curtypeurl = to.query.type;
		    this.getUserList();
  			this.getCourseList();
  			this.getpostList();
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	padding:63px 15%;
	.back
		display:flex;
		align-items:center;
		font-size:18px;
		color:#686F84;
		cursor: pointer;
		width:70px;
		margin-bottom:10px;
		img
			margin-right:5px;
	.top
		text-align:center;
		.top-title
			height:59px;
			font-size:42px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:59px;
		.top-input
			margin-top:36px;
			width:517px;
	.sel
		margin-top:80px;
		display:flex;
		cursor:pointer;
		padding:0 10px;
		border-bottom:1px solid rgba(241,241,241,1);
		.list
			padding:15px 20px 15px 0px;
			margin-right:20px;
			font-size:18px;
			font-weight:400;
			border-bottom:4px solid #fff;
		.list-sel
			color:rgba(7,19,54,1);
			border-bottom:4px solid rgba(39,81,203,1);
		.list-not
			color:rgba(7,19,54,0.6);
	.user
		padding:36px 42px 0px;
		display:flex;
		justify-content:space-between;
		flex-wrap: wrap;
		margin-bottom:50px;
		min-height:370px;
		.u-list
			width:568px;
			height:128px;
			background:rgba(255,255,255,1);
			box-shadow:0px 2px 10px 0px rgba(39,81,203,0.11);
			display:flex;
			justify-content:space-between;
			margin-bottom:36px;
			.u-list-left
				display:flex;
				margin:20px 0px 0px 18px;
				position:relative;
				cursor:pointer;
				.u-img
					width:80px;
					height:80px;
					border-radius:52px;
					margin-right:17px;
				.lawyer-img
					width:54px;
					height:20px;
					position:absolute;
					bottom:22px;
					left:15px;
				.u-name
					height:22px;
					font-size:16px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:22px;
				.u-names
					height:17px;
					font-size:12px;
					font-weight:500;
					color:rgba(7,19,54,0.4);
					line-height:17px;
				.u-company
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.6);
					line-height:20px;
					margin-top:5px;
				.u-tags
					display:flex;
					margin-top:6px;
					.u-tag-list
						padding:0px 10px;
						height:24px;
						line-height:24px;
						background:rgba(247,247,247,1);
						border-radius:12px;
						margin-right:8px;
						font-size:12px;
						color:rgba(85,85,85,1);
			.u-list-right
				font-size:16px;
				font-weight:500;
				text-align:center;
				cursor:pointer;
				.follow
					width:86px;
					height:64px;
					line-height:64px;
					background:rgba(39,81,203,1);
					color:#fff;
				.consult
					width:86px;
					height:64px;
					line-height:64px;
					background:rgba(233,239,255,1);
					color:rgba(39,81,203,1);
	.bottom
		margin:0px auto;
		text-align:center;
		.nodata
			text-align:center;
			height:22px;
			font-size:16px;
			font-weight:400;
			color:rgba(7,19,54,0.4);
			line-height:22px;
	.no-search
		text-align:center;
		.no-img
			width:300px;
			height:300px;
			margin-bottom:10px;
	.course
		padding:36px 0px 0px;
		display:flex;
		flex-wrap: wrap;
		margin-bottom:50px;
		min-height:370px;
		.c-list
			display:flex;
			position: relative;
			margin:0px 20px 36px 10px;
			cursor:pointer;
			.c-img
				width: 410px;
				height: 170px;
				border-radius: 10px;
		  	.c-lists
				margin-right: 24px;
				position: absolute;
				left: 130px;
				top:20px;
				.c-title
					width:239px;
					height:50px;
					font-size:18px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:25px;
					overflow: hidden;
					display: -webkit-box;
					text-overflow:ellipsis;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
				.c-name
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.6);
					line-height:20px;
					margin-top:7px;
				.c-time
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.6);
					line-height:20px;
					margin-top:2px;
				.c-btn
					display: flex;
					margin-top:6px;
					.c-type
						width:85px;
						height:24px;
						line-height:24px;
						background:rgba(209,173,10,1);
						border-radius:12px;
						color: #ffffff;
						text-align: center;
						margin-right:6px;
  					.c-type-fldjt
						background-color: #5C607D;
  					.c-type-no
						background-color: #A3AB5F;
  					.c-sign
						width:60px;
						height:24px;
						line-height:24px;
						background:rgba(33,177,104,1);
						border-radius:12px;
						color: #ffffff;
						text-align: center;
  					.c-over
						background:rgba(185,185,185,1);
	.post
		padding:36px 42px 0px;
		display:flex;
		justify-content:space-between;
		flex-wrap: wrap;
		margin-bottom:50px;
		min-height:370px;
		.p-list
			width:568px;
			margin-bottom:40px;
			cursor:pointer;
			.p-top
				display:flex;
				align-items:center;
				.p-t-dian
					width:6px;
					height:6px;
					background:rgba(39,81,203,1);
					border-radius:5px;
				.p-t-title
					width:545px;
					height:38px;
					font-size:18px;
					font-weight:400;
					color:rgba(7,19,54,1);
					line-height:38px;
					letter-spacing:1px;
					white-space:nowrap;
					overflow:hidden;
					text-overflow:ellipsis;
					margin-left:10px;
			.p-bottom
				margin:6px 0px 0px 10px;
				display:flex;
				font-size:14px;
				font-weight:400;
				color:rgba(7,19,54,0.4);
				div
					margin-right:10px;
</style>
<style lang="stylus">
.top-input
	.el-input__inner
		height:40px;
		background:rgba(247,248,249,1);
		// border-radius:20px;
	.el-input__suffix
		.el-icon-search
			font-size:20px;
			margin:0px 14px;
</style>
<style lang="stylus">
.main
	em
		font-style: normal;
		color: #f00 !important;
</style>


// WEBPACK FOOTER //
// src/components/search/index.vue